class CarouselTrack extends HTMLElement {
  constructor() {
    super();
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onDotClick = this.onDotClick.bind(this);
    this.dots = [];
  }

  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    this.dotsContainer = this.querySelector('[data-dots]');

    if (!this.track || this.slides.length === 0) return;

    if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
    if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);

    if (this.dotsContainer) {
      this.buildDots();
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const index = this.slides.indexOf(entry.target);
              this.setActiveDot(index);
            }
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((slide) => this.observer.observe(slide));
    }
  }

  disconnectedCallback() {
    if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
    if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
    if (this.observer) this.observer.disconnect();
    this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
  }

  buildDots() {
    this.dots = this.slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel__dot';
      dot.setAttribute('aria-label', `Ir a la diapositiva ${index + 1}`);
      dot.dataset.index = String(index);
      dot.addEventListener('click', this.onDotClick);
      this.dotsContainer.appendChild(dot);
      return dot;
    });
    this.setActiveDot(0);
  }

  setActiveDot(index) {
    if (!this.dots.length) return;
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  onDotClick(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10);
    const slide = this.slides[index];
    if (slide) {
      slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  }

  onPrevClick() {
    this.scrollByAmount(-1);
  }

  onNextClick() {
    this.scrollByAmount(1);
  }

  scrollByAmount(direction) {
    if (!this.slides[0]) return;
    const slideWidth = this.slides[0].getBoundingClientRect().width;
    const styles = getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');
    this.track.scrollBy({ left: direction * (slideWidth + gap), behavior: 'smooth' });
  }
}

if (!customElements.get('carousel-track')) {
  customElements.define('carousel-track', CarouselTrack);
}